var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container",class:_vm.containerClass},[_c('div',{staticClass:"spinner",class:_vm.sizeClass,style:(_vm.spinnerStyle)}),(_vm.text)?_c('div',{staticClass:"spinner-text",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }